export const generatedSourceUseRightsLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-20T00:00:00.000Z",
  "mode": "deterministic-source-use-rights-ledger",
  "operatingRule": "Source records are not legal clearance. Every source needs source-specific terms/license capture, citation rules, redistribution boundary, and reviewer approval before raw payloads, provider marks, pricing data, standards text, or customer-facing commercial claims can be used.",
  "sourceCount": 33,
  "blockedSourceUseCount": 33,
  "customerUseAllowed": false,
  "rawRedistributionAllowed": false,
  "classCounts": {
    "standards-body-source": 4,
    "public-data-or-api-source": 15,
    "general-public-source": 5,
    "open-source-tool-or-code": 7,
    "commercial-public-source": 2
  },
  "riskCounts": {
    "medium": 31,
    "high": 2
  },
  "usePolicyMatrix": [
    {
      "sourceUseClass": "commercial-public-source",
      "sourceCount": 2,
      "riskLevels": [
        "high"
      ],
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "requiredRightsArtifacts": [
        "captured terms or legal page hash",
        "commercial quote/use boundary",
        "minimal excerpt policy",
        "reviewer approval before customer-facing numeric use"
      ],
      "defaultBoundary": "Commercial source values may be discussed as sourced assumptions only after terms review; no raw page/API content, pricing table reproduction, or endorsement implication.",
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "policyHash": "sha256-35785c0bd7c8fe7595f0767f8875e2ee7f9e1829b9bd1b8c27522fdac06153c1"
    },
    {
      "sourceUseClass": "general-public-source",
      "sourceCount": 5,
      "riskLevels": [
        "medium"
      ],
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "requiredRightsArtifacts": [
        "access timestamp",
        "citation format",
        "reviewer approval",
        "terms or license note"
      ],
      "defaultBoundary": "Citation-only planning context until terms, citation, and reviewer approval are captured.",
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "policyHash": "sha256-325f269a47d99b79bfdc4ef90bece887c6ba03718fb580dee357aec50ec40ff3"
    },
    {
      "sourceUseClass": "open-source-tool-or-code",
      "sourceCount": 7,
      "riskLevels": [
        "medium"
      ],
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "requiredRightsArtifacts": [
        "copyleft or redistribution compatibility review",
        "dependency version and repository URL",
        "license file or SPDX identifier",
        "notice/attribution requirement"
      ],
      "defaultBoundary": "Tool outputs and dependency names may be cited after license capture; bundling, modifying, or redistributing code/artifacts remains blocked until license compatibility is reviewed.",
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "policyHash": "sha256-915ab81d71c0f2ba9e2b1be3b37342463594e3fd7dc2d9e91f18783e5e5c946d"
    },
    {
      "sourceUseClass": "public-data-or-api-source",
      "sourceCount": 15,
      "riskLevels": [
        "medium"
      ],
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "requiredRightsArtifacts": [
        "citation and attribution note",
        "normalized record hash",
        "query URL/API parameters",
        "raw payload hash",
        "terms page or archive citation"
      ],
      "defaultBoundary": "Reviewed normalized records may become customer-facing derived values after query, payload hash, unit, uncertainty, and citation review; raw payload redistribution remains blocked.",
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "policyHash": "sha256-8093d033126ee51c3a90a2308c7fa8578cff067f33a0b02132fd65ef5a4a6011"
    },
    {
      "sourceUseClass": "standards-body-source",
      "sourceCount": 4,
      "riskLevels": [
        "medium"
      ],
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "requiredRightsArtifacts": [
        "citation format",
        "license or public-access terms note",
        "review of reproduction limits for tables, figures, and long excerpts",
        "standard identifier and version"
      ],
      "defaultBoundary": "Standards may be referenced by identifier/version and short citation only; standards text, tables, figures, and procedures remain blocked until reproduction rights are reviewed.",
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "policyHash": "sha256-9a8a000b884f860c6ea721eec51c411c2a22b8a877ecbf441d7b15ca27e2b370"
    }
  ],
  "evidenceHashes": {
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4"
  },
  "requiredGlobalReviewArtifacts": [
    "source-specific terms/license capture",
    "citation and attribution policy",
    "raw payload redistribution decision",
    "provider endorsement and trademark/brand-use check",
    "customer-facing report/export review"
  ],
  "topReviewQueue": [
    {
      "sourceId": "spacex-rideshare",
      "title": "SpaceX Rideshare Program",
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "captured terms or legal page hash"
    },
    {
      "sourceId": "nasa-clps",
      "title": "Commercial Lunar Payload Services",
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "captured terms or legal page hash"
    },
    {
      "sourceId": "spice-gf",
      "title": "SPICE Geometry Finder",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "standard identifier and version"
    },
    {
      "sourceId": "horizons-api",
      "title": "JPL Horizons API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "horizons-mercury-2024",
      "title": "JPL Horizons Mercury Physical Data",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "nist-codata",
      "title": "2022 CODATA Fundamental Physical Constants",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms or license note"
    },
    {
      "sourceId": "sbdb-api",
      "title": "JPL Small-Body Database API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "cad-api",
      "title": "SBDB Close Approach Data API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "orekit",
      "title": "Orekit",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "license file or SPDX identifier"
    },
    {
      "sourceId": "gmat",
      "title": "General Mission Analysis Tool",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "openmdao",
      "title": "OpenMDAO",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "license file or SPDX identifier"
    },
    {
      "sourceId": "dymos",
      "title": "Dymos",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "license file or SPDX identifier"
    },
    {
      "sourceId": "tudat",
      "title": "Tudat Space / TudatPy",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "license file or SPDX identifier"
    },
    {
      "sourceId": "iau-sofa",
      "title": "Standards of Fundamental Astronomy",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "standard identifier and version"
    },
    {
      "sourceId": "pds",
      "title": "Planetary Data System",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "mpc",
      "title": "Minor Planet Center Data",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "esa-psa",
      "title": "ESA Planetary Science Archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "jaxa-darts",
      "title": "DARTS Space Science Data Archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "nasa-mercury",
      "title": "Mercury Facts",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms or license note"
    },
    {
      "sourceId": "nasa-dtn",
      "title": "Delay/Disruption Tolerant Networking",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms or license note"
    },
    {
      "sourceId": "nasa-cost-estimating-handbook",
      "title": "NASA Cost Estimating Handbook",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms or license note"
    },
    {
      "sourceId": "nasa-se-handbook",
      "title": "NASA Systems Engineering Handbook",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms or license note"
    },
    {
      "sourceId": "usaspending",
      "title": "USAspending.gov",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "sec-edgar",
      "title": "SEC EDGAR",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "ccsds",
      "title": "Consultative Committee for Space Data Systems",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "standard identifier and version"
    },
    {
      "sourceId": "nasa-spdf",
      "title": "NASA Space Physics Data Facility",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "nasa-ccmc",
      "title": "Community Coordinated Modeling Center",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "noaa-swpc",
      "title": "NOAA Space Weather Prediction Center Products and Data",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "nist-chemistry-webbook",
      "title": "NIST Chemistry WebBook SRD 69",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "standard identifier and version"
    },
    {
      "sourceId": "materials-project",
      "title": "Materials Project API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "terms page or archive citation"
    },
    {
      "sourceId": "cantera",
      "title": "Cantera",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "license file or SPDX identifier"
    },
    {
      "sourceId": "moose-framework",
      "title": "MOOSE Framework",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "license file or SPDX identifier"
    },
    {
      "sourceId": "openfoam",
      "title": "OpenFOAM",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "metadataCoverage": 100,
      "blockerCount": 4,
      "nextAction": "license file or SPDX identifier"
    }
  ],
  "records": [
    {
      "sourceId": "spice-gf",
      "title": "SPICE Geometry Finder",
      "organization": "NASA NAIF",
      "trust": "primary",
      "sourceType": "ephemeris-event-software",
      "type": "official software standard",
      "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-97d74c96",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Kernel set, target/observer/constraint, tolerance, and generated window hash required.",
      "uncertaintyMode": "Kernel coverage plus geometric tolerance.",
      "metadataCoverage": 100,
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-57a8f1ccad068b602d4b88e7d82356212d59c341fa186ae3100b2a3ca6bfbcf8"
    },
    {
      "sourceId": "horizons-api",
      "title": "JPL Horizons API",
      "organization": "NASA/JPL",
      "trust": "primary",
      "sourceType": "ephemeris-api",
      "type": "official API",
      "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-9335c241",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Full Horizons query string and response timestamp required.",
      "uncertaintyMode": "API table tolerance plus downstream numeric tolerance.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-634f1bc644a849f1d3fa19ab9c7c54e099c6bfa01405b82381d39f1047e998ab"
    },
    {
      "sourceId": "horizons-mercury-2024",
      "title": "JPL Horizons Mercury Physical Data",
      "organization": "NASA/JPL Horizons",
      "trust": "primary",
      "sourceType": "body-physical-data",
      "type": "live API snapshot checked 2026-06-19",
      "url": "https://ssd.jpl.nasa.gov/api/horizons.api?format=json&COMMAND=%27199%27&OBJ_DATA=%27YES%27&MAKE_EPHEM=%27NO%27",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-5b941f40",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Body-data query and retrieved physical constants required.",
      "uncertaintyMode": "Source-body data plus formula tolerance.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-12eeea9d4632e292d07a977508a77eff9ec4992106e30a5f7cdf0fb307a33acf"
    },
    {
      "sourceId": "nist-codata",
      "title": "2022 CODATA Fundamental Physical Constants",
      "organization": "NIST",
      "trust": "primary",
      "sourceType": "physical-constants",
      "type": "official constants table",
      "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-333cff52",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Constants release and exact constant identifiers required.",
      "uncertaintyMode": "CODATA uncertainty or exact-SI status.",
      "metadataCoverage": 100,
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-0cc3a1436931190c0a07c880c51c5aa65b06e78d7a215e22669f69f07f6a9b5a"
    },
    {
      "sourceId": "sbdb-api",
      "title": "JPL Small-Body Database API",
      "organization": "NASA/JPL",
      "trust": "primary",
      "sourceType": "small-body-orbit-api",
      "type": "official API",
      "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-93c0fe91",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
      "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-a10ef09edab1a69fc6e05ed4a0e463eaa6d6aaf964d9712d6953716a02792e3b"
    },
    {
      "sourceId": "cad-api",
      "title": "SBDB Close Approach Data API",
      "organization": "NASA/JPL CNEOS",
      "trust": "primary",
      "sourceType": "close-approach-api",
      "type": "official API",
      "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-ba0c45bb",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
      "uncertaintyMode": "Nominal approach values with orbit-solution caveats.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-62d5fd81325c14b2bdbf7f978f1f17863dde84034fbdc040bb41daffe39c1a42"
    },
    {
      "sourceId": "orekit",
      "title": "Orekit",
      "organization": "CS Group / open source community",
      "trust": "open-source",
      "sourceType": "astrodynamics-library",
      "type": "open-source astrodynamics library",
      "url": "https://www.orekit.org/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-88a8d672",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Tool version, data context, frames, force model, and checksums required.",
      "uncertaintyMode": "Model configuration and independent comparison residuals.",
      "metadataCoverage": 100,
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-df79afad6216381464b72fba5c94f119b314989cf6fc060d31a4dfcf4cbfe0e2"
    },
    {
      "sourceId": "gmat",
      "title": "General Mission Analysis Tool",
      "organization": "NASA",
      "trust": "primary",
      "sourceType": "mission-analysis-tool",
      "type": "official open-source mission analysis tool",
      "url": "https://software.nasa.gov/software/GSC-17177-1",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-3743e565",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "GMAT script hash, version, force model, optimizer, and run summary required.",
      "uncertaintyMode": "Constraint residuals and cross-tool comparison.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-640eb6ce03eab0fee2e7a93ec615a4538c492bce831462ab13a2b19ab82212b5"
    },
    {
      "sourceId": "openmdao",
      "title": "OpenMDAO",
      "organization": "NASA",
      "trust": "primary",
      "sourceType": "optimization-framework",
      "type": "open-source optimization framework",
      "url": "https://openmdao.org/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-9ef7d3cb",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Problem definition, design variables, constraints, objective, and seed required.",
      "uncertaintyMode": "Sensitivity and optimizer-convergence metadata.",
      "metadataCoverage": 100,
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-527154357d0a395242916a3a43246c58e5fb556ade38cc917e14228ddeea7abf"
    },
    {
      "sourceId": "dymos",
      "title": "Dymos",
      "organization": "OpenMDAO project",
      "trust": "open-source",
      "sourceType": "optimal-control-library",
      "type": "open-source optimal-control library",
      "url": "https://openmdao.github.io/dymos/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-31dbd31c",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Problem definition, transcription, optimizer, constraints, objective, and run seed required.",
      "uncertaintyMode": "Convergence status, sensitivity, and collocation residuals.",
      "metadataCoverage": 100,
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-fffae5de932bec6e92a8d52b83686a2b6ab47f5232fbbd5fd1a100064d90de86"
    },
    {
      "sourceId": "tudat",
      "title": "Tudat Space / TudatPy",
      "organization": "TU Delft Astrodynamics Toolbox community",
      "trust": "open-source",
      "sourceType": "astrodynamics-toolkit",
      "type": "open-source astrodynamics toolkit",
      "url": "https://docs.tudat.space/en/latest/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-c238f1d2",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Tool version, body settings, integrator, propagator, and output hashes required.",
      "uncertaintyMode": "Integrator settings, model configuration, and cross-tool residual bounds.",
      "metadataCoverage": 100,
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-a3b4f73cdfc87599c32e25fc0d2e30bf82bc9d713c9c8de3facf1ed8355ad843"
    },
    {
      "sourceId": "iau-sofa",
      "title": "Standards of Fundamental Astronomy",
      "organization": "IAU SOFA",
      "trust": "primary",
      "sourceType": "astronomy-standards",
      "type": "official astronomy standards",
      "url": "https://www.iausofa.org/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-2a854c84",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Routine/version reference and transformation chain required.",
      "uncertaintyMode": "Standards conformance and transform precision.",
      "metadataCoverage": 100,
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-c1fc511b99907ba9fd2367df76679f7522e8eedd8f3e8944b4d6e31313cb88be"
    },
    {
      "sourceId": "pds",
      "title": "Planetary Data System",
      "organization": "NASA",
      "trust": "primary",
      "sourceType": "mission-data-archive",
      "type": "official archive",
      "url": "https://pds.nasa.gov/datasearch/data-search/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-7c477cc2",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
      "uncertaintyMode": "Instrument/product calibration metadata.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-f43ee31285ff21cd83d07c4271839c8ed49107622706aeea80f77e800c2b2652"
    },
    {
      "sourceId": "mpc",
      "title": "Minor Planet Center Data",
      "organization": "International Astronomical Union Minor Planet Center",
      "trust": "primary",
      "sourceType": "small-body-observation-archive",
      "type": "official small-body observation data",
      "url": "https://minorplanetcenter.net/data",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-62694497",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
      "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-d6603a5739948b62381ecda8f42c02a966328a5b6599902b78bd4ca6a90fb1d2"
    },
    {
      "sourceId": "esa-psa",
      "title": "ESA Planetary Science Archive",
      "organization": "European Space Agency",
      "trust": "primary",
      "sourceType": "planetary-mission-archive",
      "type": "official planetary mission archive",
      "url": "https://archives.esac.esa.int/psa/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-5c0abe4d",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
      "uncertaintyMode": "Product calibration, processing level, and instrument caveats.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-cf3a2609993fae8446f717c9b51ba0016ec3893ebf788cfe0b4b48ca0c115b44"
    },
    {
      "sourceId": "jaxa-darts",
      "title": "DARTS Space Science Data Archive",
      "organization": "ISAS/JAXA",
      "trust": "primary",
      "sourceType": "space-science-archive",
      "type": "official space science archive",
      "url": "https://darts.isas.jaxa.jp/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-e07b656d",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
      "uncertaintyMode": "Dataset calibration and archive release notes.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-9f8a54aebe3282c2c5fb96c5673305f9ecf04331cf10fc630be87e697038b8dc"
    },
    {
      "sourceId": "nasa-mercury",
      "title": "Mercury Facts",
      "organization": "NASA Science",
      "trust": "primary",
      "sourceType": "official-factsheet",
      "type": "official factsheet",
      "url": "https://science.nasa.gov/mercury/facts/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-78229f8d",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Page URL, access date, and derived-calculation trace required.",
      "uncertaintyMode": "Factsheet summary caveats; not a substitute for mission data.",
      "metadataCoverage": 100,
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-7220d6133064aea0d8732df451938606ec8fa3f17cd86b08308cc182b758a11e"
    },
    {
      "sourceId": "nasa-dtn",
      "title": "Delay/Disruption Tolerant Networking",
      "organization": "NASA SCaN",
      "trust": "primary",
      "sourceType": "communications-program-reference",
      "type": "official program page",
      "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-61e03fe6",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Program reference, architecture assumption, and scenario mapping required.",
      "uncertaintyMode": "Conceptual architecture until mission-specific link data exists.",
      "metadataCoverage": 100,
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-1a7de1a7203b5facf55e1002995c1c12d9e096255991504e90609fd8b00f1ad7"
    },
    {
      "sourceId": "spacex-rideshare",
      "title": "SpaceX Rideshare Program",
      "organization": "SpaceX",
      "trust": "commercial-primary",
      "sourceType": "commercial-launch-pricing",
      "type": "commercial launch pricing page",
      "url": "https://www.spacex.com/rideshare/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-86aacff8",
      "declaredLicenseNote": "Commercial public web page; quote minimally and preserve citation rather than redistributing raw content.",
      "queryPolicy": "Capture provider page, access timestamp, price table text, destination/orbit class, and terms caveats before use.",
      "uncertaintyMode": "Commercial list price caveats, mission-specific integration costs, schedule, destination, and contract terms.",
      "metadataCoverage": 100,
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "requiredRightsArtifacts": [
        "captured terms or legal page hash",
        "commercial quote/use boundary",
        "minimal excerpt policy",
        "reviewer approval before customer-facing numeric use"
      ],
      "redistributionBoundary": "Do not redistribute raw page/API content; cite source and preserve derived normalized values only after terms review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-e8ca9a05bb0a4360b3f6a386245e9656c43d07ea998a13b602f09b0a5f0100d8"
    },
    {
      "sourceId": "nasa-clps",
      "title": "Commercial Lunar Payload Services",
      "organization": "NASA",
      "trust": "primary",
      "sourceType": "commercial-lunar-delivery-program",
      "type": "official commercial lunar delivery program page",
      "url": "https://www.nasa.gov/commercial-lunar-payload-services/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-7d151be6",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Capture NASA program page, date, task-order references, provider, payload mass/context, and award amount where available.",
      "uncertaintyMode": "Task-order scope, modifications, mission risk, provider performance, and payload-specific services.",
      "metadataCoverage": 100,
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "requiredRightsArtifacts": [
        "captured terms or legal page hash",
        "commercial quote/use boundary",
        "minimal excerpt policy",
        "reviewer approval before customer-facing numeric use"
      ],
      "redistributionBoundary": "Do not redistribute raw page/API content; cite source and preserve derived normalized values only after terms review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-e6b104bc250fb970a5a671bb87341936f58099195b93270240970c1f7b8eb1b2"
    },
    {
      "sourceId": "nasa-cost-estimating-handbook",
      "title": "NASA Cost Estimating Handbook",
      "organization": "NASA",
      "trust": "primary",
      "sourceType": "cost-estimating-methodology",
      "type": "official cost-estimating guidance",
      "url": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-a82e1046",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Document handbook version, estimating method, normalization year, risk treatment, and applied model assumptions.",
      "uncertaintyMode": "Method selection, analogy quality, learning curves, schedule risk, and normalization assumptions.",
      "metadataCoverage": 100,
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-85a80d06f9389a1ef1c50bd568cb94482d3585d2fe47db58ce5ba9e88563bb11"
    },
    {
      "sourceId": "nasa-se-handbook",
      "title": "NASA Systems Engineering Handbook",
      "organization": "NASA",
      "trust": "primary",
      "sourceType": "systems-engineering-methodology",
      "type": "official systems-engineering handbook",
      "url": "https://www.nasa.gov/reference/systems-engineering-handbook/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-991637e4",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Document handbook version, review/maturity concept used, and mapping to scenario/process gates.",
      "uncertaintyMode": "Program-specific tailoring and maturity-assessment subjectivity.",
      "metadataCoverage": 100,
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-79a3344de218d982b0026380a394d25c1c9418417bf5a299c799e2a80ccbd436"
    },
    {
      "sourceId": "usaspending",
      "title": "USAspending.gov",
      "organization": "U.S. Treasury / federal agencies",
      "trust": "primary",
      "sourceType": "federal-award-database",
      "type": "official federal award data",
      "url": "https://www.usaspending.gov/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-fb43b155",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Preserve query filters, award id, recipient, agency, obligation amounts, date range, and retrieval hash.",
      "uncertaintyMode": "Award modification timing, obligation versus outlay, scope classification, and recipient hierarchy.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-18f06378501568ad1ca153e06ca34d18481b416e9dec26668dccc2743a97f6b7"
    },
    {
      "sourceId": "sec-edgar",
      "title": "SEC EDGAR",
      "organization": "U.S. Securities and Exchange Commission",
      "trust": "primary",
      "sourceType": "public-company-filings",
      "type": "official public company filing database",
      "url": "https://www.sec.gov/edgar",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-f2e84204",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Preserve CIK/ticker, accession number, filing date, statement section, XBRL fields, and retrieval hash.",
      "uncertaintyMode": "Company-specific accounting policy, segment allocation, forward-looking statements, and market-cycle caveats.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-811fbc05e0a75da2cd347130d23c8124d3491bf67fcb9a14784ab03ec0ae908a"
    },
    {
      "sourceId": "ccsds",
      "title": "Consultative Committee for Space Data Systems",
      "organization": "CCSDS member agencies",
      "trust": "primary",
      "sourceType": "space-data-standard",
      "type": "international space data and communications standards",
      "url": "https://ccsds.org/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-75fdfe19",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Publication id, version, area, and applied assumption required.",
      "uncertaintyMode": "Standards conformance caveats and mission-specific implementation deltas.",
      "metadataCoverage": 100,
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-662635bb0ff5db183a550d210208407fd3cb52181375ebfca24eb0db5a3c1c3c"
    },
    {
      "sourceId": "nasa-spdf",
      "title": "NASA Space Physics Data Facility",
      "organization": "NASA Goddard",
      "trust": "primary",
      "sourceType": "heliophysics-data-archive",
      "type": "official heliophysics data archive",
      "url": "https://spdf.gsfc.nasa.gov/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-05f4400c",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Dataset id, variables, time range, cadence, and retrieval hash required.",
      "uncertaintyMode": "Instrument calibration, cadence, and archive-version caveats.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-5740526eebb9601d64ebdad188c624842e80adc9b88de5bbf47232381464f0bc"
    },
    {
      "sourceId": "nasa-ccmc",
      "title": "Community Coordinated Modeling Center",
      "organization": "NASA Goddard",
      "trust": "primary",
      "sourceType": "space-weather-modeling-center",
      "type": "official space-weather modeling center",
      "url": "https://ccmc.gsfc.nasa.gov/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-1a450de5",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Model, run id, inputs, version, and output hash required.",
      "uncertaintyMode": "Model validation state, run configuration, and uncertainty bounds.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-ef154fda79149df0df7ee8d1e84187eb1ed91c405e7bc4c98526a037f0c79dd2"
    },
    {
      "sourceId": "noaa-swpc",
      "title": "NOAA Space Weather Prediction Center Products and Data",
      "organization": "NOAA/NWS",
      "trust": "primary",
      "sourceType": "space-weather-products",
      "type": "official space-weather products",
      "url": "https://www.spaceweather.gov/products-and-data",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-dbbbdd09",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Product id, issue time, forecast horizon, and archive link required.",
      "uncertaintyMode": "Forecast horizon and product-specific verification notes.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-c72eb81eee2fcbd6841b3d9d64f5d41580524d28860661c54c5a51448a479dff"
    },
    {
      "sourceId": "nist-chemistry-webbook",
      "title": "NIST Chemistry WebBook SRD 69",
      "organization": "NIST",
      "trust": "primary",
      "sourceType": "chemistry-reference-database",
      "type": "standard reference chemistry database",
      "url": "https://webbook.nist.gov/chemistry/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-d9ac987b",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Species identifier, property table, units, citation, and access date required.",
      "uncertaintyMode": "NIST data notes, property method, and cited evaluation caveats.",
      "metadataCoverage": 100,
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-16a6c3c35a922108b06ef50833ef43ebfbe6d1f662cf8cf5202e21ccc9558d5d"
    },
    {
      "sourceId": "materials-project",
      "title": "Materials Project API",
      "organization": "Lawrence Berkeley National Laboratory / Materials Project",
      "trust": "primary",
      "sourceType": "materials-property-api",
      "type": "open materials database API",
      "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-c46b2daa",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "mp-id, fields, API version/client, method metadata, and retrieval hash required.",
      "uncertaintyMode": "DFT/method limitations, provenance, and contributed-data caveats.",
      "metadataCoverage": 100,
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-92083d9e756372d7fc89be368f9bd389c77c9bac73b02a46f14f11d1176acc21"
    },
    {
      "sourceId": "cantera",
      "title": "Cantera",
      "organization": "Cantera project",
      "trust": "open-source",
      "sourceType": "chemistry-transport-toolkit",
      "type": "open-source chemistry and transport toolkit",
      "url": "https://cantera.org/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-883bdb34",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Mechanism file, tool version, inputs, outputs, and mechanism hash required.",
      "uncertaintyMode": "Mechanism validity range and solver tolerance.",
      "metadataCoverage": 100,
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-50a5dfe354dc940b42f8eeeadfd4bb9013a3ad7d35cfe907e00b74566ad2fe09"
    },
    {
      "sourceId": "moose-framework",
      "title": "MOOSE Framework",
      "organization": "Idaho National Laboratory",
      "trust": "primary",
      "sourceType": "multiphysics-framework",
      "type": "open-source multiphysics framework",
      "url": "https://mooseframework.inl.gov/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-a9482599",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Input file, application/version, mesh hash, material data, and output hash required.",
      "uncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty.",
      "metadataCoverage": 100,
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-8238d3e76b4f3780f90dc80a602bf63d758347ab8134d282a19c78628cf4f75a"
    },
    {
      "sourceId": "openfoam",
      "title": "OpenFOAM",
      "organization": "OpenCFD / OpenFOAM community",
      "trust": "open-source",
      "sourceType": "cfd-toolkit",
      "type": "open-source CFD toolkit",
      "url": "https://www.openfoam.com/",
      "capturedAt": "2026-06-19",
      "sourceRecordHash": "fnv1a32-124056ab",
      "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
      "queryPolicy": "Case directory hash, solver/version, mesh, boundary conditions, and result hash required.",
      "uncertaintyMode": "Mesh convergence, turbulence model, chemistry model, and boundary-condition uncertainty.",
      "metadataCoverage": 100,
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "citationBoundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement.",
      "reviewGate": {
        "termsCaptured": false,
        "reviewerApproved": false,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-pending-source-use-review",
        "blockers": [
          "Source-specific license or terms artifact is not captured.",
          "Source-use reviewer approval is not recorded.",
          "Raw source payload redistribution is not allowed by this ledger.",
          "Customer/commercial use is blocked until rights review passes."
        ],
        "allowedUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance."
      },
      "sourceUseHash": "sha256-5ef7497b07d3f325ac1ea3c70735459b841d21a61fba9819a27f73539e75bcb0"
    }
  ],
  "ledgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
}
;
